window.GlobalQuickView = (() => {
    let currentProduct = null;
    let currentVariant = null;
    let currentColor = null;

    const els = {};

    function init() {
        els.root = document.getElementById("GlobalQuickView");
        if (!els.root) return;

        els.title = document.getElementById("GlobalQuickViewTitle");
        els.price = document.getElementById("GlobalQuickViewPrice");
        els.colorsWrap = document.getElementById("GlobalQuickViewColorsWrap");
        els.colors = document.getElementById("GlobalQuickViewColors");
        els.sizesWrap = document.getElementById("GlobalQuickViewSizesWrap");
        els.size = document.getElementById("GlobalQuickViewSize");
        els.main = document.getElementById("GlobalQuickViewMain");
        els.addToCart = document.getElementById("GlobalQuickViewAddToCart");
        els.details = document.getElementById("GlobalQuickViewDetails");

        if (
            !els.title ||
            !els.price ||
            !els.colorsWrap ||
            !els.colors ||
            !els.sizesWrap ||
            !els.size ||
            !els.main ||
            !els.addToCart ||
            !els.details
        ) {
            console.warn("GlobalQuickView: faltan elementos del popup");
            return;
        }

        bindEvents();
        bindTriggers(document);
    }

    function bindEvents() {
        els.root.querySelectorAll("[data-quick-view-close]").forEach((el) => {
            el.addEventListener("click", close);
        });

        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape" && els.root.classList.contains("is-open")) {
                close();
            }
        });

        els.size.addEventListener("change", onSizeChange);
        els.addToCart.addEventListener("click", addToCart);
    }

    function bindTriggers(scope = document) {
        scope.querySelectorAll("[data-quick-view-trigger]").forEach((btn) => {
            if (btn.dataset.quickViewBound === "true") return;
            btn.dataset.quickViewBound = "true";

            btn.addEventListener("click", async (e) => {
                e.preventDefault();
                e.stopPropagation();

                try {
                    const jsonId = btn.dataset.productJsonId;
                    const handle = btn.dataset.productHandle;
                    const initialVariantId = btn.dataset.initialVariantId
                        ? Number(btn.dataset.initialVariantId)
                        : null;

                    if (jsonId) {
                        const jsonEl = document.getElementById(jsonId);

                        if (!jsonEl) {
                            console.warn(
                                "GlobalQuickView: no se encontró el JSON",
                                jsonId,
                            );
                            return;
                        }

                        const raw = jsonEl.textContent?.trim();
                        if (!raw) {
                            console.warn("GlobalQuickView: JSON vacío", jsonId);
                            return;
                        }

                        const product = JSON.parse(raw);
                        open(product, { initialVariantId });
                        return;
                    }

                    if (handle) {
                        const response = await fetch(`/products/${handle}.js`);
                        if (!response.ok) {
                            throw new Error(
                                "No se pudo cargar el producto por handle",
                            );
                        }

                        const product = await response.json();
                        open(product, { initialVariantId });
                    }
                } catch (error) {
                    console.error("GlobalQuickView error al abrir:", error);
                }
            });
        });
    }

    function open(product, options = {}) {
        if (!product) return;

        currentProduct = normalizeProduct(product);

        const initialVariant = getVariantById(
            currentProduct,
            options.initialVariantId,
        );

        currentVariant =
            initialVariant ||
            (currentProduct.variants || []).find((v) => v.available) ||
            currentProduct.variants?.[0] ||
            null;

        const colorIndex = getOptionIndex(currentProduct, ["color", "colour"]);
        currentColor =
            colorIndex > -1 && currentVariant?.options
                ? currentVariant.options[colorIndex]
                : null;

        render();
        els.root.classList.add("is-open");
        document.body.style.overflow = "hidden";
    }

    function close() {
        els.root.classList.remove("is-open");
        document.body.style.overflow = "";

        currentProduct = null;
        currentVariant = null;
        currentColor = null;

        els.title.textContent = "";
        els.price.innerHTML = "";
        els.colors.innerHTML = "";
        els.size.innerHTML = "";
        els.main.innerHTML = "";
        els.details.href = "#";
    }

    function normalizeProduct(product) {
        return {
            ...product,
            url: product.url || `/products/${product.handle}`,
            options: product.options || [],
            images: (product.images || []).map((img) =>
                typeof img === "string"
                    ? normalizeImageUrl(img)
                    : normalizeImageUrl(img.src),
            ),
            variants: (product.variants || []).map((variant) => {
                let options = variant.options;

                if (!options || !Array.isArray(options)) {
                    options = [];
                    if (variant.option1 !== undefined)
                        options.push(variant.option1);
                    if (variant.option2 !== undefined)
                        options.push(variant.option2);
                    if (variant.option3 !== undefined)
                        options.push(variant.option3);
                }

                return {
                    ...variant,
                    options,
                    featured_image: variant.featured_image
                        ? {
                              ...variant.featured_image,
                              src: normalizeImageUrl(
                                  variant.featured_image.src,
                              ),
                          }
                        : null,
                    featured_media: variant.featured_media?.preview_image?.src
                        ? {
                              ...variant.featured_media,
                              preview_image: {
                                  ...variant.featured_media.preview_image,
                                  src: normalizeImageUrl(
                                      variant.featured_media.preview_image.src,
                                  ),
                              },
                          }
                        : variant.featured_media || null,
                };
            }),
        };
    }

    function getVariantById(product, variantId) {
        if (!product?.variants?.length || !variantId) return null;

        return (
            product.variants.find(
                (variant) => Number(variant.id) === Number(variantId),
            ) || null
        );
    }

    function normalizeImageUrl(url) {
        if (!url) return "";
        if (url.startsWith("//")) return `https:${url}`;
        return url;
    }

    function getLightboxImageSrc(url) {
        if (!url) return "";

        const normalized = normalizeImageUrl(url);

        // Shopify CDN pattern: replace existing sized suffix with 2400x when present.
        return normalized.replace(
            /_(pico|icon|thumb|small|compact|medium|large|grande|[0-9]+x)\.(jpg|jpeg|png|webp|avif)(\?.*)?$/i,
            "_2400x.$2$3",
        );
    }

    function render() {
        if (!currentProduct) return;

        els.title.textContent = currentProduct.title || "";
        els.details.href = currentProduct.url || "#";

        renderPrice();
        renderImages();
        renderColors();
        renderSizes();
        updateAddToCartState();
    }

    function renderPrice() {
        if (!currentVariant) {
            els.price.innerHTML = "";
            return;
        }

        let html = "";

        if (
            currentVariant.compare_at_price &&
            Number(currentVariant.compare_at_price) >
                Number(currentVariant.price)
        ) {
            html += `<s>${formatMoney(currentVariant.compare_at_price)}</s>`;
        }

        html += `<span>${formatMoney(currentVariant.price)}</span>`;
        els.price.innerHTML = html;
    }

    function renderImages() {
        els.main.innerHTML = "";

        let images = getColorGroupedImages(currentProduct, currentColor);

        if (!images.length && currentVariant?.featured_image?.src) {
            images = [currentVariant.featured_image.src];
        }

        images = [
            ...new Set(
                images.map((img) =>
                    normalizeImageUrl(typeof img === "string" ? img : img.src),
                ),
            ),
        ].filter(Boolean);

        if (!images.length) return;

        images.forEach((src, index) => {
            const thumb = document.createElement("img");
            thumb.src = src;
            thumb.alt = currentProduct.title || "";
            thumb.className =
                "global-quick-view__thumb" + (index === 0 ? " is-active" : "");
            thumb.dataset.index = index;

            const mediaItem = document.createElement("div");
            mediaItem.className = "global-quick-view__media-item";

            const img = document.createElement("img");
            img.src = src;
            img.alt = currentProduct.title || "";
            img.dataset.index = index;
            img.setAttribute("data-lightbox-image", "");
            img.dataset.lightboxSrc = getLightboxImageSrc(src);

            mediaItem.appendChild(img);
            els.main.appendChild(mediaItem);

            thumb.addEventListener("click", () => {
                els.root
                    .querySelectorAll(".global-quick-view__thumb")
                    .forEach((item) => item.classList.remove("is-active"));

                thumb.classList.add("is-active");

                const target = els.main.querySelector(
                    `img[data-index="${index}"]`,
                );
                if (target) {
                    target.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    });
                }
            });
        });
    }

    function renderColors() {
        const colorIndex = getOptionIndex(currentProduct, ["color", "colour"]);
        els.colors.innerHTML = "";

        if (colorIndex === -1) {
            els.colorsWrap.style.display = "none";
            return;
        }

        els.colorsWrap.style.display = "";

        const colorItems = [];
        const seenColors = new Set();

        (currentProduct.variants || []).forEach((variant) => {
            const color = variant.options?.[colorIndex];
            if (!color || seenColors.has(color)) return;

            const imageSrc =
                variant.featured_image?.src ||
                variant.featured_media?.preview_image?.src ||
                getColorGroupedImages(currentProduct, color)?.[0] ||
                currentProduct.images?.[0] ||
                "";

            seenColors.add(color);

            colorItems.push({
                color,
                imageSrc: normalizeImageUrl(imageSrc),
                available: !!variant.available,
            });
        });

        colorItems.forEach(({ color, imageSrc, available }) => {
            const btn = document.createElement("button");
            btn.type = "button";
            btn.className =
                "global-quick-view__swatch global-quick-view__swatch--image";
            btn.setAttribute("aria-label", color);
            btn.setAttribute("title", color);

            if (color === currentColor) btn.classList.add("is-active");
            if (!available) btn.classList.add("is-disabled");

            btn.innerHTML = `
                <span class="global-quick-view__swatch-image-wrap">
                    ${
                        imageSrc
                            ? `<img src="${imageSrc}" alt="${color}" class="global-quick-view__swatch-image">`
                            : `<span class="global-quick-view__swatch-image-placeholder">${color}</span>`
                    }
                </span>
            `;

            btn.addEventListener("click", () => {
                currentColor = color;
                updateVariantFromSelection();
                render();
            });

            els.colors.appendChild(btn);
        });
    }

    function renderSizes() {
        const sizeIndex = getOptionIndex(currentProduct, ["size", "talla"]);
        els.size.innerHTML = "";

        if (sizeIndex === -1) {
            els.sizesWrap.style.display = "none";
            return;
        }

        els.sizesWrap.style.display = "";

        let variants = currentProduct.variants || [];

        const colorIndex = getOptionIndex(currentProduct, ["color", "colour"]);
        if (colorIndex !== -1 && currentColor) {
            variants = variants.filter(
                (variant) => variant.options?.[colorIndex] === currentColor,
            );
        }

        const sizes = [
            ...new Set(
                variants
                    .map((variant) => variant.options?.[sizeIndex])
                    .filter(Boolean),
            ),
        ];

        sizes.forEach((size) => {
            const option = document.createElement("option");
            option.value = size;
            option.textContent = size;
            els.size.appendChild(option);
        });

        const selectedSize =
            currentVariant?.options?.[sizeIndex] || sizes[0] || "";

        els.size.value = selectedSize;
    }

    function onSizeChange() {
        updateVariantFromSelection();
        renderPrice();
        renderImages();
        updateAddToCartState();
    }

    function updateVariantFromSelection() {
        if (!currentProduct) return;

        const colorIndex = getOptionIndex(currentProduct, ["color", "colour"]);
        const sizeIndex = getOptionIndex(currentProduct, ["size", "talla"]);
        const selectedSize = sizeIndex !== -1 ? els.size.value : null;

        currentVariant =
            (currentProduct.variants || []).find((variant) => {
                const colorMatch =
                    colorIndex === -1 ||
                    !currentColor ||
                    variant.options?.[colorIndex] === currentColor;

                const sizeMatch =
                    sizeIndex === -1 ||
                    !selectedSize ||
                    variant.options?.[sizeIndex] === selectedSize;

                return colorMatch && sizeMatch && variant.available;
            }) ||
            (currentProduct.variants || []).find((variant) => {
                const colorMatch =
                    colorIndex === -1 ||
                    !currentColor ||
                    variant.options?.[colorIndex] === currentColor;

                const sizeMatch =
                    sizeIndex === -1 ||
                    !selectedSize ||
                    variant.options?.[sizeIndex] === selectedSize;

                return colorMatch && sizeMatch;
            }) ||
            null;
    }

    function updateAddToCartState() {
        if (!currentVariant) {
            els.addToCart.disabled = true;
            els.addToCart.textContent = "NO DISPONIBLE";
            return;
        }

        els.addToCart.disabled = !currentVariant.available;
        els.addToCart.textContent = currentVariant.available
            ? "AGREGAR AL CARRITO"
            : "AGOTADO";
    }

    async function addToCart() {
        if (!currentVariant || !currentVariant.id) return;

        try {
            const response = await fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify({
                    id: currentVariant.id,
                    quantity: 1,
                }),
            });

            if (!response.ok) {
                throw new Error("No se pudo agregar al carrito");
            }

            els.addToCart.textContent = "AGREGADO";
            document.dispatchEvent(new CustomEvent("cart:refresh"));

            setTimeout(() => {
                close();
            }, 400);

            setTimeout(() => {
                updateAddToCartState();
            }, 1200);
        } catch (error) {
            console.error("GlobalQuickView addToCart error:", error);
            els.addToCart.textContent = "ERROR";

            setTimeout(() => {
                updateAddToCartState();
            }, 1200);
        }
    }

    function getOptionIndex(product, names) {
        return (product.options || []).findIndex((opt) =>
            names.includes(String(opt).trim().toLowerCase()),
        );
    }

    function formatMoney(cents) {
        const amount = Number(cents || 0) / 100;

        return amount.toLocaleString("es-MX", {
            style: "currency",
            currency: "MXN",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }

    function getColorGroupedImages(product, selectedColor) {
        if (!product || !product.images?.length) return [];

        const colorIndex = getOptionIndex(product, ["color", "colour"]);
        if (colorIndex === -1 || !selectedColor) {
            return product.images;
        }

        const colorVariants = [];
        const seenColors = new Set();

        (product.variants || []).forEach((variant) => {
            const colorValue = variant.options?.[colorIndex];
            if (!colorValue || seenColors.has(colorValue)) return;

            const featuredSrc =
                variant.featured_image?.src ||
                variant.featured_media?.preview_image?.src ||
                null;

            if (featuredSrc) {
                seenColors.add(colorValue);
                colorVariants.push({
                    color: colorValue,
                    featuredSrc: normalizeImageUrl(featuredSrc),
                });
            }
        });

        if (!colorVariants.length) return product.images;

        const ranges = colorVariants
            .map((item) => {
                const startIndex = product.images.findIndex(
                    (img) => normalizeImageUrl(img) === item.featuredSrc,
                );

                return {
                    color: item.color,
                    featuredSrc: item.featuredSrc,
                    startIndex,
                };
            })
            .filter((item) => item.startIndex !== -1)
            .sort((a, b) => a.startIndex - b.startIndex);

        if (!ranges.length) return product.images;

        const currentRangeIndex = ranges.findIndex(
            (item) => item.color === selectedColor,
        );

        if (currentRangeIndex === -1) return product.images;

        const start = ranges[currentRangeIndex].startIndex;
        const end =
            currentRangeIndex < ranges.length - 1
                ? ranges[currentRangeIndex + 1].startIndex
                : product.images.length;

        return product.images.slice(start, end);
    }

    return {
        init,
        open,
        close,
        bindTriggers,
    };
})();

document.addEventListener("DOMContentLoaded", () => {
    window.GlobalQuickView.init();
});
